angular.module("dx.webapp.printing").controller("DxPrintExamRouteController", function PrintExamRouteController(
	$routeParams,
	$location,
	$window,
	$rootScope,
	$document,
	$cookies,
	$http,
	dxSession,
	NodeRepository,
	Exam,
	ExamRepository,
	DX_URLS,
	DX_EXAM_PARTS,
	DX_PAGE_BREAK,
	DX_SORT_OPTIONS,
	DX_STUDENT_SORT_PREDICATE,
	dxBitFlagsHelper,
	dxEvent,
	DX_SPELLCHECKSETTING,
	DX_GRADING_TYPES,
	DX_PRINT_SETTINGS,
	DX_NODE_IMAGES,
	dxSorting,
	dxAngularConstantHelper,
	dxDialog
	// jsPDF
) {
	"use strict";

	var self = this;

	var DX_EVENT_NAME = dxAngularConstantHelper.DX_EVENT_NAME;

	// Global properties
	self.exam = new Exam();
	self.selectedQuestions = [];
	self.students = [];
	self.loading = true;
	self.loadingOnePdf = false;
	self.loadingMultiplePdf = false;
	self.DX_SPELLCHECKSETTING = DX_SPELLCHECKSETTING;
	self.printContents = [];
	self.nodeProfileImage = null;
	self.disabledStudentCodes = false;
	self.isPrintSettingsShown = false;
	self.downloadAsOne = false;
	self.downloadAsMultiple = false;
	self.htmlElements = [];
	// Parse route parameters
	self.params = {};
	self.params.examId = $routeParams.id === null ? 0 : parseInt($routeParams.id, 10);
	self.params.pageBreakBefore = $routeParams.pageBreakBefore;
	self.params.printSettings = $routeParams.printSettings === null ? DX_PRINT_SETTINGS.DEFAULT : parseInt($routeParams.printSettings, 10);

	// If clicked "Preview exam" from "Exams" view
	var shouldPrintExamTemplate = $location.path().includes("/exam/print/");

	if (shouldPrintExamTemplate) {
		self.params.examParts = $routeParams.examParts ? parseInt($routeParams.examParts, 10) : DX_EXAM_PARTS.EXAM_PRINT_PARTS;
		self.params.sortOn = "showOnlyQuestions";
	} else {
		self.params.examParts = $routeParams.examParts ? parseInt($routeParams.examParts, 10) : DX_EXAM_PARTS.ALL_PARTS;
		self.params.questionIds = csvToIntArray($routeParams.questionIds);
		self.params.studentIds = csvToIntArray($routeParams.studentIds);
		self.params.sortOn = $routeParams.sortOn;
	}

	var isPageBreakStudent = self.params.pageBreakBefore === DX_PAGE_BREAK.PAGE_BREAK_STUDENT;
	var isPageBreakQuestion = self.params.pageBreakBefore === DX_PAGE_BREAK.PAGE_BREAK_QUESTION;
	var isSortOnStudents = self.params.sortOn === DX_SORT_OPTIONS.STUDENTS;

	// Load data
	ExamRepository.load(self.params.examId).then(loadedExamSuccess, loadedExamFailed);

	self.dxSession = dxSession;
	NodeRepository.load(dxSession.getRole().organizationId).then(function onNodeLoadSuccess(node) {
		if (node.getProfileImage() !== DX_NODE_IMAGES.PROFILE) {
			self.nodeProfileImage = node.getProfileImage();
		}

		self.disabledStudentCodes = node.disabledStudentCodes;
	});

	function loadedExamSuccess(exam) {
		self.exam = exam;
		if (shouldPrintExamTemplate) {
			var questionIds = [];
			for (var i = 0; i < exam.questions.length; i++) {
				questionIds.push(exam.questions[i].id);
			}
			self.params.questionIds = questionIds;
		}

		if (shouldPrintExamTemplate) {
			populateQuestions();
		} else {
			self.exam.getGrades().then(function getGradesSuccess() {
				populateQuestions();
			});
		}
	}

	function populateQuestions() {
		self.loading = false;

		for (var questionIndex = 0; questionIndex < self.exam.questions.length; questionIndex++) {
			var question = self.exam.questions[questionIndex];
			var selected = (self.params.questionIds.indexOf(question.id) !== -1);
			self.selectedQuestions.push({
				question: selected ? question : null,
				selected: selected,
			});
		}

		for (var studentIndex = 0; studentIndex < self.exam.students.length; studentIndex++) {
			var student = self.exam.students[studentIndex];
			if (self.params.studentIds && self.params.studentIds.indexOf(student.id) !== -1) {
				self.students.push(student);
			}
		}
		setPrintContent();
	}

	function loadedExamFailed() {
		$location.path(DX_URLS.get(404));
	}

	self.print = function print() {
		dxEvent.create(shouldPrintExamTemplate ?
			DX_EVENT_NAME.EventExamPrinted :
			DX_EVENT_NAME.EventGradingPrinted,
		[{key: "examId", value: self.exam.id}]);
		$window.print();
	};

	self.downloadAsOnePdf = function downloadAsOnePdf() {
		self.loadingOnePdf = true;
		self.downloadAsOne = true;
		setDxPrintAnswerItem();
	};

	self.cloudPrintDialog = function cloudPrintDialog() {
		var scope = $rootScope.$new();
		scope.errorMessage = "";
		scope.clicked = false;

		scope.singleFile = true;
		scope.email = self.dxSession.getUser().email[0];

		scope.close = function close() {
			dxDialog.closeMostRecent();
		};

		scope.getIdentifier = function getIdentifier(student) {
			var displayName = "";
			if (self.hasPrintSetting(self.DX_PRINT_SETTINGS.SHOW_NAME)) {
				displayName += student.getName(false, false);
			}
			if (self.disabledStudentCodes || self.hasPrintSetting(self.DX_PRINT_SETTINGS.SHOW_STUDENT_CODE)) {
				displayName += " (" + student.code + ")";
			}
			if (self.hasPrintSetting(self.DX_PRINT_SETTINGS.SHOW_EMAIL)) {
				displayName += " " + student.email;
			}
			if (self.exam.anonymous) {
				//Default option for anonymous exams
				displayName = student.getName(false, false);
			}
			return displayName;
		};

		scope.cloudPrint = function cloudPrint() {
			scope.clicked = true;

			scope.studentIdentifications = [];

			if (!scope.singleFile) {
				// eslint-disable-next-line func-names
				angular.forEach(self.students, function forEachStudent(student) {
					scope.studentIdentifications.push(scope.getIdentifier(student));
				});
			}

			var region = $cookies.get("region");

			// Cloud print is printing students in order of checked students.
			// The correct order is under $routeParams.studentIds.
			// To have matching names with files while printing
			// as multiple files we need to sort studentsIdentifications.
			var sortedIdsByCheckedBoxes = csvToIntArray($routeParams.studentIds);
			var studentsIdentifications = scope.studentIdentifications;

			if (sortedIdsByCheckedBoxes) {
				var studentsArrayCopy = self.students.slice();
				studentsArrayCopy.sort(function(a, b) {  //eslint-disable-line
					return sortedIdsByCheckedBoxes.indexOf(a.id) - sortedIdsByCheckedBoxes.indexOf(b.id);
				});

				studentsIdentifications = studentsArrayCopy.map(function(student) { //eslint-disable-line
					return scope.getIdentifier(student);
				});
			}

			var params = JSON.stringify({
				user: $cookies.get("user"),
				region: region,
				csrf: $cookies.get("csrf"),
				recentRole: $cookies.get("recentRole"),
				role: $cookies.get("role"),
				url: $window.location.href,
				to: scope.email,
				singleFile: scope.singleFile,
				title: self.exam.title,
				date: self.exam.start,
				lang: $cookies.get("language"),
				identifications: studentsIdentifications,
				loginOrigin: $cookies.get("loginOrigin"),
				ltiNodeId: $cookies.get("ltiNodeId"),
			});

			var url = "";

			switch (region) {
				case "USA":
					url = "https://digiexam-printer-6grliv4hsa-uc.a.run.app/print";
					break;
				case "Development":
					url = "https://digiexam-printer-kxovmouayq-ew.a.run.app/print";
					break;
				default:
					url = "https://digiexam-printer-konfkiv3ua-ew.a.run.app/print";
					break;
			}

			$http.post(
				url,
				params
				// eslint-disable-next-line func-names
			).then(function() {
				// eslint-disable-next-line func-names
			}, function(error) {
				scope.errorMessage = error.data;
				scope.loading = false;
			});
		};

		dxDialog.show({
			templateUrl: "tmpl/printing/print-cloud-dialog.html",
			$scope: scope,
		});
	};

	self.downloadAsMultiplePdf = function downloadAsMultiplePdf() {
		self.loadingMultiplePdf = true;
		self.downloadAsMultiple = true;
		setDxPrintAnswerItem();
	};

	self.setLoadingPdf = function setLoadingPdf(value) {
		self.loadingOnePdf = value;
		self.loadingMultiplePdf = value;
		resetPdfDownload();
	};

	self.back = function back() {
		$window.history.back();
	};

	self.DX_EXAM_PARTS = DX_EXAM_PARTS;
	self.DX_PRINT_SETTINGS = DX_PRINT_SETTINGS;

	self.shouldShowMatrix = function shouldShowMatrix() {
		if (self.exam === null) {
			return false;
		} else if (self.exam.gradingMatrix === null) {
			return false;
		} else if (self.exam.gradingType !== DX_GRADING_TYPES.FORMATIVE) {
			return false;
		} else if (!self.hasExamPart(DX_EXAM_PARTS.EXAM_GRADING_MATRIX)) {
			return false;
		}
		return true;
	};

	self.pageBreakNone = function pageBreakNone() {
		return self.params.pageBreakBefore === DX_PAGE_BREAK.NO_PAGE_BREAK;
	};

	self.pageBreakTitle = function pageBreakTitle() {
		return self.params.pageBreakBefore === DX_PAGE_BREAK.PAGE_BREAK_TITLE;
	};

	self.isFinalResult = function isFinalResult() {
		var finalGrade = self.hasExamPart(DX_EXAM_PARTS.FINAL_GRADE);
		var teacherNote = self.hasExamPart(DX_EXAM_PARTS.FINAL_TEACHER_NOTE);
		return (finalGrade || teacherNote);
	};

	self.hasExamPart = function hasExamPart(examPart) {
		return dxBitFlagsHelper.isBitIncluded(self.params.examParts, examPart);
	};

	self.hasPrintSetting = function hasPrintSetting(printSetting) {
		return dxBitFlagsHelper.isBitIncluded(self.params.printSettings, printSetting);
	};

	function setDxPrintAnswerItem() {
		self.htmlElements = $document[0].querySelectorAll("dx-print-answer-item");
	}

	function resetPdfDownload() {
		self.downloadAsOne = false;
		self.downloadAsMultiple = false;
	}

	function setPrintContent() {
		sortPrintContents();
		switch (self.params.sortOn) {
			case "students":
				generateListOnStudent();
				break;
			case "questions":
				generateListOnQuestion();
				break;
			case "showOnlyQuestions":
				generateListWithOnlyQuestions();
				break;
			default:
				break;
		}
	}

	function sortPrintContents() {
		if (!$rootScope.studentSortOptions) {
			var sortPredicate = self.exam.anonymous ? DX_STUDENT_SORT_PREDICATE.ANONYMOUS_ID : DX_STUDENT_SORT_PREDICATE.NAME;
			$rootScope.studentSortOptions = {
				predicate: sortPredicate,
				reverse: false,
			};
		}

		self.students = dxSorting.studentSort(self.students, $rootScope.studentSortOptions);
	}

	function generateListOnStudent() {
		for (var studentIndex = 0; studentIndex < self.students.length; studentIndex++) {
			for (var questionIndex = 0; questionIndex < self.selectedQuestions.length; questionIndex++) {
				var selected = self.selectedQuestions[questionIndex].selected;
				self.printContents.push(createQuestionItem(studentIndex, questionIndex, selected, false));
			}
			self.printContents.push(createResultsItem(studentIndex));
		}
	}

	function generateListWithOnlyQuestions() {
		for (var questionIndex = 0; questionIndex < self.selectedQuestions.length; questionIndex++) {
			var selected = self.selectedQuestions[questionIndex].selected;
			self.printContents.push(createQuestionItem(0, questionIndex, selected, true));
		}
	}

	function generateListOnQuestion() {
		var studentIndex = 0;
		for (var questionIndex = 0; questionIndex < self.selectedQuestions.length; questionIndex++) {
			var selected = self.selectedQuestions[questionIndex].selected;
			for (studentIndex = 0; studentIndex < self.students.length; studentIndex++) {
				self.printContents.push(createQuestionItem(studentIndex, questionIndex, selected, false));
			}
		}
		for (studentIndex = 0; studentIndex < self.students.length; studentIndex++) {
			self.printContents.push(createResultsItem(studentIndex));
		}
	}

	function createQuestionItem(studentIndex, questionIndex, selected, buildOnlyQuestions) {
		var skipUnanswered = self.hasPrintSetting(DX_PRINT_SETTINGS.SKIP_UNANSWERED_QUESTIONS);
		var student = self.students[studentIndex];

		var returnObject = {
			question: self.selectedQuestions[questionIndex].question,
			showOnlyQuestions: buildOnlyQuestions,
			breakBefore: shouldPrependPageBreak((studentIndex === 0), (questionIndex === 0)),
			blankPage: shouldAppendBlankPage((studentIndex === self.students.length - 1)),
		};

		if (!buildOnlyQuestions) {
			var studentAnswer = student ? student.answers[questionIndex] : null;
			var studentHasAnswer = studentAnswer ? studentAnswer.hasAnswer() : false;

			returnObject.student = student;
			returnObject.studentAnswer = studentAnswer;
			returnObject.finalResult = false;
			returnObject.skip = !selected || (skipUnanswered && !studentHasAnswer);
		}
		return returnObject;
	}

	function createResultsItem(studentIndex) {
		var isFinalResult = true;
		return {
			question: null,
			student: self.students[studentIndex],
			studentAnswer: null,
			finalResult: isFinalResult,
			blankPage: shouldAppendBlankPage((studentIndex === self.students.length - 1), isFinalResult),
			breakBefore: shouldPrependPageBreak((studentIndex === 0)),
			skip: false,
		};
	}

	function shouldAppendBlankPage(lastStudent, isResultItem) {
		var blankPage = self.hasPrintSetting(DX_PRINT_SETTINGS.BLANK_PAGE);
		if (shouldPrintExamTemplate) {
			return blankPage;
		}

		if (isSortOnStudents) {
			return lastStudent ? false : (isResultItem && blankPage);
		}
		return isResultItem ? false : (lastStudent && blankPage);
	}

	function shouldPrependPageBreak(firstStudent, firstQuestion) {
		if (isSortOnStudents) {
			return firstQuestion ? isPageBreakStudent || isPageBreakQuestion : isPageBreakQuestion;
		}
		return firstStudent ? isPageBreakStudent || isPageBreakQuestion : isPageBreakStudent;
	}

	function csvToIntArray(csv) {
		if (!csv) {
			return [];
		}

		return csv.split(",").map(function mapping(value) {
			return parseInt(value, 10);
		});
	}
});
